// HomeWeb.jsx
import React, { useState, useRef, useEffect  } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../../components/baseWeb';
import styles from '../../styles/formularios';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
export default function DadosContradadoCorretorWeb({ route }) {
  const navigation = useNavigation();
  // envio unico 

  const [usuario_id, setUsuario_id] = useState(null);
  const { payload_prop, endereco_imovel } = route.params || {};

  console.log("Dados recebidos:", payload_prop, endereco_imovel)
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [corretores, setCorretores] = useState([
    {
      nomeCompleto: '',
      cnpj_contratado: '',
      creci: '',
      participacao: '',
      tel_contratado: '',
      cep_contratado: '',
      endereco_contratado: '',
      complemento_contratado: '',
      bairro_contratado: '',
      cidadeUf_contratado: '',
    },
  ]);

  const nomeCompletoRef = useRef([]);
  const cnpjRef = useRef([]);
  const cepRef = useRef([]);

  const atualizarCorretor = (index, campo, valor) => {
    const novoscorretores = [...corretores];
    novoscorretores[index][campo] = valor;
    setCorretores(novoscorretores);
  };

  const adicionarCorretor = () => {
    setCorretores([
      ...corretores,
      {
        nomeCompleto: '',
        cnpj_contratado: '',
        creci: '',
        participacao: '',
        tel_contratado: '',
        cep_contratado: '',
        endereco_contratado: '',
        complemento_contratado: '',
        bairro_contratado: '',
        cidadeUf_contratado: '',
      },
    ]);
  };

  const handleCepChange = (text, index) => {
    const formattedCep = text.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2');
    atualizarCorretor(index, 'cep_contratado', formattedCep);
    if (formattedCep.length === 9) {
      atualizarEnderecoViaCep(formattedCep, index);
    }
  };

  const atualizarEnderecoViaCep = async (cep, index) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`);
      if (response.data) {
        const novoscorretores = [...corretores];
        const p = { ...novoscorretores[index] };

        // Atualiza com base no que foi retornado, mantendo campo editável
        p.endereco_contratado = response.data.logradouro || p.endereco_contratado;
        p.bairro_contratado = response.data.bairro || p.bairro_contratado;
        p.cidadeUf_contratado = `${response.data.localidade}/${response.data.uf}` || p.cidadeUf_contratado;

        novoscorretores[index] = p;
        setCorretores(novoscorretores);
      }
    } catch (error) {
      Alert.alert('Erro', 'Não foi possível buscar o CEP');
    }
  };

  const isEmailValido = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isFormValid = () => {
    const totalParticipacao = corretores.reduce((sum, p) => sum + Number(p.participacao || 0), 0);
    const camposOk = corretores.every((p) =>
      p.nomeCompleto && p.cnpj_contratado && p.cep_contratado && p.creci && p.participacao
    );
    return camposOk && totalParticipacao === 100;
  };

  const handleSaveImovel = async () => {
    const totalParticipacao = corretores.reduce((sum, p) => sum + Number(p.participacao || 0), 0);

    if (corretores.length > 1 && totalParticipacao !== 100) {
      return corretores.reduce((total, p) => total + Number(p.participacao || 0), 0);
    }
    const corretoresFormatados = corretores.map((p) => {
      const [cidade, uf] = (p.cidadeUf_contratado || '').split('/');

      return {
        nome: p.nomeCompleto,
        cnpj: p.cnpj_contratado,
        endereco: `${p.endereco_contratado} ${p.complemento_contratado}`,
        telefone: p.tel_contratado,
        creci: p.creci,
        participacao: Number(p.participacao),
        cidade: cidade?.trim() || '',
        cep: p.cep_contratado,
        uf: uf?.trim() || '',
      };
    });

    const payloadCompleto = {
      ...payload_prop,
      corretores: corretoresFormatados
    };

    navigation.navigate('EtapasCorretagemWeb', { status: 4, payload_corretores: payloadCompleto, endereco_imovel });

    console.log('Payload Final:', JSON.stringify(payloadCompleto, null, 2));
  };

  useEffect(() => {
    if (corretores.length === 1) {
      setCorretores([{ ...corretores[0], participacao: '100' }]);
    }
  }, [corretores.length]);

  const somaParticipacao = () => {
    return corretores.reduce((total, p) => total + Number(p.participacao || 0), 0);
  };

  return (
    <BaseWeb>
      {(userInfo) => {
        return (
          <ScrollView contentContainerStyle={styles.contentMinimal}>
            <View style={styles.formContainer}>
              <Text style={styles.title}>Dados do(s) contratado(s)</Text>

              {corretores.map((p, index) => (
                <View key={index} style={styles.CorretorContainer}>
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Nome ou Razão Social</Text>
                    <TextInput
                      ref={(ref) => (nomeCompletoRef.current[index] = ref)}
                      style={styles.areaInput}
                      placeholder="Nome ou Razão Social"
                      value={p.nomeCompleto}
                      onChangeText={(text) => atualizarCorretor(index, 'nomeCompleto', text)}
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>CNPJ</Text>
                    <MaskInput
                      ref={(ref) => (cnpjRef.current[index] = ref)}
                      style={styles.areaInput}
                      value={p.cnpj_contratado}
                      onChangeText={(text) => atualizarCorretor(index, 'cnpj_contratado', text)}
                      mask={Masks.BRL_CNPJ}
                      placeholder="00.000.000/0000-00"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                    />
                  </View>

                  {/* Novo: CRECI */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>CRECI</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.creci}
                      onChangeText={(text) => atualizarCorretor(index, 'creci', text.replace(/\D/g, ''))}
                      placeholder="Número do CRECI"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                      maxLength={10}
                    />
                  </View>

                  {/* Novo: Participação */}
                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Participação (%)</Text>
                    <TextInput
                      style={[styles.areaInput, corretores.length === 1 && { backgroundColor: '#eee' }]}
                      value={p.participacao}
                      onChangeText={(text) => atualizarCorretor(index, 'participacao', text.replace(/\D/g, ''))}
                      placeholder="Ex: 50"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                      maxLength={3}
                      editable={corretores.length !== 1}
                    />
                    {corretores.length > 1 && index === corretores.length - 1 && (
                      <Text
                        style={{
                          color: somaParticipacao() === 100 ? '#077755' : 'red',
                          marginTop: 5,
                          fontSize: 12,
                        }}
                      >
                        Total de participação: {somaParticipacao()}% {somaParticipacao() !== 100 && '(precisa ser 100%)'}
                      </Text>
                    )}
                  </View>



                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Telefone</Text>
                    <MaskInput
                      style={styles.areaInput}
                      value={p.tel_contratado}
                      onChangeText={(text) => atualizarCorretor(index, 'tel_contratado', text)}
                      mask={Masks.BRL_PHONE}
                      placeholder="(00) 00000-0000"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="phone-pad"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>CEP</Text>
                    <TextInput
                      ref={(ref) => (cepRef.current[index] = ref)}
                      style={styles.areaInput}
                      value={p.cep_contratado}
                      onChangeText={(text) => handleCepChange(text, index)}
                      placeholder="00.000-000"
                      placeholderTextColor="#A9A9A9"
                      keyboardType="numeric"
                      maxLength={9}
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Endereço</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.endereco_contratado}
                      onChangeText={(text) => atualizarCorretor(index, 'endereco_contratado', text)}
                      placeholder="Rua, Avenida..."
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Complemento</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.complemento_contratado}
                      onChangeText={(text) => atualizarCorretor(index, 'complemento_contratado', text)}
                      placeholder="Apto, Bloco..."
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Bairro</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.bairro_contratado}
                      onChangeText={(text) => atualizarCorretor(index, 'bairro_contratado', text)}
                      placeholder="Bairro"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.row}>
                    <Text style={styles.subLabel}>Cidade/UF</Text>
                    <TextInput
                      style={styles.areaInput}
                      value={p.cidadeUf_contratado}
                      onChangeText={(text) => atualizarCorretor(index, 'cidadeUf_contratado', text)}
                      placeholder="Cidade/UF"
                      placeholderTextColor="#A9A9A9"
                    />
                  </View>

                  <View style={styles.divider} />
                </View>
              ))}

              {/* Inputs de Área */}

              <TouchableOpacity style={styles.laterButton} onPress={adicionarCorretor}>
                <Text style={styles.laterButtonText}>Adicionar contratado</Text>
              </TouchableOpacity>
              {/* Botão Salvar */}
              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[
                    styles.saveButton,
                    (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                  ]}
                  onPress={handleSaveImovel}
                  disabled={!isFormValid() || isSubmitting} // Desabilita durante a submissão
                >
                  <Text style={styles.saveButtonText} allowFontScaling={false}>
                    {isSubmitting ? "Enviando..." : "Salvar"}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity style={styles.laterButton}>
                  <Image
                    source={require('../../../assets/icons/bookmark.png')} // Ícone de terminar mais tarde
                    style={styles.laterIcon}
                  />
                  <Text
                    style={styles.laterButtonText}
                    allowFontScaling={false}
                    onPress={() => navigation.navigate('Home', { usuario_id })}
                  >
                    Terminar mais tarde
                  </Text>
                </TouchableOpacity>
              </View>

            </View>
          </ScrollView>
        );
      }}
    </BaseWeb>
  );
}
